
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store, StoreMutations } from '@/store';
import { FilterCampionarioProduzione } from '@/models';

@Component
export default class OpzioniOrdiniComandi extends Vue {    
    
    get toggleViewIcon(): string {
        return store.state.uiOrdini.listView ? 'mdi-apps' : 'mdi-format-list-bulleted';
    }

    private toggleView() {
        store.commit(StoreMutations.OrdiniUiToggleListView);
    }

    private mostraOpzioni() {
        store.commit(StoreMutations.SetOpzioniVisibili, true);
    }

    get filtriApplicati(): boolean {
        let applicati = store.state.uiOrdini.filtri.filtroModelli.length > 0;
        applicati = applicati || store.state.uiOrdini.filtri.numOrdine.length > 0;        
        applicati = applicati || store.state.uiOrdini.filtri.filtroStagioni.length > 0;        
        applicati = applicati || store.state.uiOrdini.filtri.filtroFasi.length > 0;        
        applicati = applicati || store.state.uiOrdini.filtri.mostraCompletati;
        applicati = applicati || store.state.uiOrdini.filtri.soloUSA;
        applicati = applicati || store.state.uiOrdini.filtri.campionarioEProduzione != FilterCampionarioProduzione.CampionarioEProduzione;        

        return applicati;
    }
}

